<section class="flex flex-col gap-4 pb-6">
  <header class="flex flex-col gap-1">
    <h1 class="text-lg font-semibold text-[#3d2652]">
      {{ "mobile.eachat.list.title" | translate }}
    </h1>
    <p class="text-sm text-[#7a6b8a]">
      {{ "mobile.eachat.list.subtitle" | translate }}
    </p>
  </header>

  @if (listStatus() === "loading") {
    <div class="flex justify-center py-10">
      <span class="material-icons animate-spin text-[#5a2f6b]" aria-hidden="true">progress_activity</span>
    </div>
  } @else if (listStatus() === "error") {
    <div class="rounded-xl border border-destructive/20 bg-destructive/5 p-4 text-center">
      <p class="text-sm text-destructive">{{ "mobile.eachat.list.error" | translate }}</p>
      <button
        type="button"
        class="mt-3 rounded-lg bg-[#5a2f6b] px-4 py-2 text-sm font-semibold text-white"
        (click)="reload()"
      >
        {{ "common.retry" | translate }}
      </button>
    </div>
  } @else if (!tickets().length) {
    <div
      class="flex flex-col items-center gap-3 rounded-2xl border border-[#ece4f3] bg-[#faf7fc] px-4 py-10 text-center"
    >
      <span
        class="inline-flex h-14 w-14 items-center justify-center rounded-full bg-white text-[#5a2f6b] shadow-sm"
      >
        <span class="material-icons text-[28px]" aria-hidden="true">request_quote</span>
      </span>
      <p class="text-sm font-semibold text-[#3d2652]">
        {{ "mobile.eachat.list.empty" | translate }}
      </p>
    </div>
  } @else {
    <ul class="flex min-w-0 flex-col gap-2" role="list">
      @for (ticketInfo of tickets(); track trackTicket($index, ticketInfo)) {
        <li>
          <div
            class="demand-list-card flex w-full min-w-0 flex-col gap-3 overflow-hidden rounded-xl border border-[#ece4f3] bg-white px-3 py-3 text-left shadow-sm"
          >
            <div class="flex items-start gap-2">
              <span
                class="inline-flex h-11 w-11 shrink-0 items-center justify-center rounded-xl bg-[#efe6f6] text-[#5a2f6b]"
              >
                <span class="material-icons text-[22px] leading-none" aria-hidden="true">{{
                  mobileTicketTypeMaterialIcon(ticketInfo)
                }}</span>
              </span>
              <div class="min-w-0 flex-1">
                <span class="block truncate text-sm font-semibold text-[#1a1523]">
                  {{ ticketInfo.Label?.trim() || ("mobile.eachat.list.unnamed" | translate) }}
                </span>
                @if (ticketInfo.FunctionalId?.trim()) {
                  <span class="mt-0.5 block truncate font-mono text-[0.7rem] text-[#7a6b8a]">{{
                    ticketInfo.FunctionalId
                  }}</span>
                }
                <div class="mt-1.5 flex flex-wrap items-center gap-1.5">
                  <span
                    class="inline-flex max-w-full items-center gap-1 rounded-full px-2 py-0.5 text-[0.65rem] font-semibold"
                    [class]="mobileTicketTypeBadgeClass(ticketInfo)"
                  >
                    <span class="material-icons shrink-0 text-[14px]" aria-hidden="true">{{
                      mobileTicketTypeMaterialIcon(ticketInfo)
                    }}</span>
                    <span class="min-w-0 truncate">{{ mobileTicketTypeDisplayLabel(ticketInfo) }}</span>
                  </span>
                  @if (ticketInfo.EntityStatus; as entityStatus) {
                    @if (entityStatus.Label) {
                      <span
                        class="inline-flex max-w-full items-center gap-1.5 rounded-full bg-[#f5f0fa] px-2 py-0.5 text-[0.65rem] font-medium text-[#5a2f6b]"
                      >
                        <span
                          class="h-2.5 w-2.5 shrink-0 rounded-full ring-2 ring-black/5"
                          [style.background-color]="mobileEntityStatusDotColor(entityStatus.ColorHexa)"
                          aria-hidden="true"
                        ></span>
                        <span class="min-w-0 truncate">{{ entityStatus.Label }}</span>
                      </span>
                    }
                  }
                </div>
              </div>
            </div>

            <dl class="demand-list-fields grid min-w-0 gap-2 text-[0.75rem] leading-snug text-[#3d2652]">
              <div class="demand-list-field-row">
                <dt class="demand-list-field-label">{{ "mobile.eachat.field.type" | translate }}</dt>
                <dd class="demand-list-field-value">
                  {{ mobileTicketTypeDisplayLabel(ticketInfo) }}
                </dd>
              </div>
              <div class="demand-list-field-row">
                <dt class="demand-list-field-label">{{ "mobile.eachat.field.requester" | translate }}</dt>
                <dd class="demand-list-field-value" [title]="mobileTicketRequesterLabel(ticketInfo)">
                  {{
                    mobileTicketRequesterLabel(ticketInfo) || ("app.shared.notprovided" | translate)
                  }}
                </dd>
              </div>
              <div class="demand-list-field-row">
                <dt class="demand-list-field-label">{{ "mobile.eachat.field.recipient" | translate }}</dt>
                <dd class="demand-list-field-value" [title]="mobileTicketRecipientLabel(ticketInfo)">
                  {{
                    mobileTicketRecipientLabel(ticketInfo) || ("app.shared.notprovided" | translate)
                  }}
                </dd>
              </div>
            </dl>

            <div class="flex items-center justify-end gap-1 border-t border-[#ece4f3] pt-3">
              @if (ticketAccess().hasReadAccess) {
                <button
                  type="button"
                  class="inline-flex h-9 w-9 items-center justify-center rounded-lg border border-[#ece4f3] bg-[#faf7fc] text-[#5a2f6b] shadow-sm active:scale-95"
                  (click)="openDemandDetail(ticketInfo.Uid, $event)"
                  [attr.aria-label]="'mobile.eachat.list.openDetail' | translate"
                >
                  <span class="material-icons-outlined text-[20px]" aria-hidden="true">visibility</span>
                </button>
              }
            </div>
          </div>
        </li>
      }
    </ul>
  }
</section>
